import React, { useState } from "react";
import { motion } from "framer-motion";
import Modal from "./portfolioDetailModal";
import { PROJECTS } from "../constants/projects";

const DEFAULT_IMAGE =
  "https://images.unsplash.com/photo-1511707171635-7e1f9c2d5f8f";

export const PortfolioCard = ({
  projectKey,
  image = DEFAULT_IMAGE,
  type = "project",
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: "",
    images: [],
    details: {},
  });

  const handleOpenModal = () => {
    const projectDetails = PROJECTS[projectKey];
    if (projectDetails) {
      setModalContent({
        title: projectDetails.title,
        images:
          projectDetails.galleryImages &&
          projectDetails.galleryImages.length > 0
            ? projectDetails.galleryImages
            : [DEFAULT_IMAGE],
        details: projectDetails,
      });
      setModalOpen(true);
    } else {
      console.error("Project details not found for key:", projectKey);
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const project = PROJECTS[projectKey];
  const isCertificate = type === "certificate";

  return (
    <>
      <motion.article
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        whileHover={{ y: -10, transition: { duration: 0.25 } }}
        onClick={handleOpenModal}
        className={`portfolio-card ${isCertificate ? "certificate-card" : "project-card"}`}
      >
        <div className="portfolio-image-wrap">
          <img
            src={image}
            alt={project?.title || "Project"}
            className="portfolio-image"
          />
          <div className="portfolio-image-overlay" />
          <span className="portfolio-badge">
            {isCertificate ? "Certificate" : project?.type || "Project"}
          </span>
        </div>

        <div className="portfolio-card-body">
          <h3>{project?.title || "Project Title"}</h3>

          {!isCertificate && (
            <>
              <p>
                {project?.description?.substring(0, 90) ||
                  "Delivering business-focused digital products with modern architecture and strong UX."}
                {project?.description?.length > 90 ? "..." : ""}
              </p>
              <div className="portfolio-techs">
                {(project?.technologies || ["React", "Node.js"])
                  .slice(0, 3)
                  .map((tech) => (
                    <span key={tech}>{tech}</span>
                  ))}
              </div>
            </>
          )}

          {isCertificate && (
            <p className="certificate-copy">
              Click to view certificate details
            </p>
          )}
        </div>
      </motion.article>

      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title={modalContent.title}
        details={modalContent.details}
        images={modalContent.images}
        backgroundImage={image}
      />
    </>
  );
};
